import { Menu, MenuItem, styled } from '@nextiva/next-ui-components';

export const StyledMenu = styled(Menu)({
  '& > .MuiPaper-root': {
    minWidth: 214,
  },
});

export const StyledMenuHeader = styled(MenuItem)(({ theme }) => ({
  fontSize: 10,
  color: theme.palette.blueGrey.A600,
  cursor: 'auto',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: 'inherit',
  },
}));

export const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  flexDirection: 'row',
  '& > *:not(:last-child)': {
    marginRight: 8,
  },
});
